"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Convierte un Blobk a una cadena base64 */
function blobToBase64(archivo) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = function () {
            const dataUrl = reader.result;
            //Caso especial, si el blob viene vacio esto devuelve "data:"
            if (dataUrl == "data:")
                resolve("");
            const base64Prefix = "base64,";
            const base64 = dataUrl.substring(dataUrl.indexOf(base64Prefix) + base64Prefix.length);
            resolve(base64);
        };
        reader.readAsDataURL(archivo);
    });
}
exports.blobToBase64 = blobToBase64;
/**Convierte un Blob a una cadena  */
function blobToRaw(archivo) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsBinaryString(archivo);
    });
}
exports.blobToRaw = blobToRaw;
/**Convierte una cadena base64 a un blob */
function base64ToBlob(base64, contentType) {
    //Este codigo fue tomado de
    //http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript#16245768
    contentType = contentType || '';
    var byteCharacters = atob(base64);
    return stringToBlob(byteCharacters, contentType);
}
exports.base64ToBlob = base64ToBlob;
function stringToBlob(value, contentType) {
    const sliceSize = 512;
    const byteArrays = [];
    for (let offset = 0; offset < value.length; offset += sliceSize) {
        const slice = value.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
exports.stringToBlob = stringToBlob;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/files.js
// module id = 212
// module chunks = 0